<template>
  <v-data-table :headers="headers" :items="localCategories" class="elevation-1" :items-per-page="-1" mobile-breakpoint="768" disable-sort>
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>カテゴリマスタ</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialogAdd" persistent>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on">カテゴリの新規作成</v-btn>
          </template>
          <v-form ref="form">
            <v-card>
              <v-card-title>
                <span class="text-h5">カテゴリの新規作成</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedCategory.name" label="カテゴリ" :rules="[rules.required]" autofocus></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-select v-model="editedCategory.color" :items="colors" label="カテゴリカラー" :rules="[rules.required]"></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeAdd">キャンセル</v-btn>
                <v-btn color="blue darken-1" text @click="localAddCategory">新規作成</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
        <v-dialog v-model="dialogEdit" persistent>
          <v-form ref="form">
            <v-card>
              <v-card-title>
                <span class="text-h5">変更</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedCategory.name" label="カテゴリ" :rules="[rules.required]" autofocus></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-select v-model="editedCategory.color" :items="colors" label="カテゴリカラー" :rules="[rules.required]"></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeEdit">キャンセル</v-btn>
                <v-btn color="blue darken-1" text @click="localEditCategory">変更</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
        <v-dialog v-model="dialogDelete" persistent>
          <v-form>
            <v-card>
              <v-card-title>
                <span class="text-h5">このカテゴリを削除してよろしいですか？</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedCategory.name" label="カテゴリ" disabled></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-select v-model="editedCategory.color" :items="colors" label="カテゴリカラー" disabled></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete">キャンセル</v-btn>
                <v-btn color="blue darken-1" text @click="localDeleteCategory">削除</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:[`item.name`]="{ item }">
      <v-chip :color="getColor(item.color)" dark>
        {{ item.name }}
      </v-chip>
    </template>
    <template v-slot:[`item.action`]="{ item }">
      <v-icon @click="openEdit(item)"> mdi-pencil </v-icon>
    </template>
    <template v-slot:[`item.action2`]="{ item }">
      <v-icon @click="openDelete(item)"> mdi-delete </v-icon>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      dialogAdd: false,
      dialogEdit: false,
      dialogDelete: false,
      headers: [
        { text: "カテゴリ", value: "name" },
        { text: "カテゴリカラー", value: "color", align: "center" },
        { text: "変更", value: "action", align: "center" },
        { text: "削除", value: "action2", align: "center" },
      ],
      localCategories: [],
      editedCategory: { id: "", name: "", color: "" },
      defaultCategory: { id: "", name: "", color: "" },
      rules: {
        required: (value) => !!value || "入力必須です。",
      },
      colors: ["青", "緑", "橙", "灰", "黒"],
    };
  },
  created() {
    this.localCategories = this.$store.state.categories;
  },
  watch: {
    dialogAdd(val) {
      val || this.closeAdd();
    },
    dialogEdit(val) {
      val || this.closeEdit();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  methods: {
    getColor(color) {
      switch (color) {
        case "青":
          return "blue";
        case "緑":
          return "green";
        case "橙":
          return "orange";
        case "灰":
          return "grey";
        case "黒":
          return "black";
      }
    },
    openEdit(category) {
      this.editedCategory = Object.assign({}, category);
      this.dialogEdit = true;
    },
    openDelete(category) {
      this.editedCategory = Object.assign({}, category);
      this.dialogDelete = true;
    },
    closeAdd() {
      this.$refs.form.resetValidation();
      this.dialogAdd = false;
      this.$nextTick(() => {
        this.editedCategory = Object.assign({}, this.defaultCategory);
      });
    },
    closeEdit() {
      this.$refs.form.resetValidation();
      this.dialogEdit = false;
      this.$nextTick(() => {
        this.editedCategory = Object.assign({}, this.defaultCategory);
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedCategory = Object.assign({}, this.defaultCategory);
      });
    },
    localAddCategory() {
      if (this.$refs.form.validate()) {
        this.addCategory(this.editedCategory);
        this.closeAdd();
      }
    },
    localEditCategory() {
      if (this.$refs.form.validate()) {
        this.updateCategory(this.editedCategory);
        this.closeEdit();
      }
    },
    localDeleteCategory() {
      this.deleteCategory(this.editedCategory.id);
      this.closeDelete();
    },
    ...mapActions(["addCategory", "updateCategory", "deleteCategory"]),
  },
};
</script>

<style></style>
